import React from 'react';
import styled from '@emotion/styled';
import { N500 } from '@atlaskit/theme/colors';

export type SocialSignUpButtonProps = {
  readonly href: string;
  readonly onClick: () => undefined;
  readonly iconUrl: string;
  readonly label: React.ReactNode;
};

export const SocialSignUpButton = ({
  href,
  onClick,
  iconUrl,
  label
}: SocialSignUpButtonProps) => {
  return (
    <SocialButton href={href} onClick={onClick}>
      <SocialButtonIcon src={iconUrl} /> {label}
    </SocialButton>
  );
};

const fontCharlieText =
  '"Charlie Text", -apple-system, BlinkMacSystemFont, "Segoe UI",' +
  'Roboto, "Noto Sans", Ubuntu, "Droid Sans", "Helvetica Neue", sans-serif !important';

export const SocialButtonIcon = styled.img`
  height: 18px;
  width: 18px;
  margin-right: 8px;
  margin-bottom: 0;
`;

export const SocialButton = styled.a`
  text-decoration: none;
  height: 39px;
  width: 100%;
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${N500};
  :hover{
    color: ${N500}
    text-decoration: none;
  }
  cursor: pointer;
  font-weight: 500;
  box-shadow: rgba(0, 0, 0, 0.2) 1px 1px 5px 0 !important;
  background-color: #FFF;

  margin: 0px 0px 20px 0px;
  padding: 0;
  border: 0;
  font-size: 100%;
  vertical-align: baseline;
  font-family: ${fontCharlieText};
  font-style: normal;
`;
